export default __webpack_public_path__ + "static/media/ps_voltage_screen.62802aff.svg";